import { render, staticRenderFns } from "./ProInfoModal.vue?vue&type=template&id=a8080d7e&scoped=true"
import script from "./ProInfoModal.vue?vue&type=script&lang=js"
export * from "./ProInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ProInfoModal.vue?vue&type=style&index=0&id=a8080d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8080d7e",
  null
  
)

export default component.exports